var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFileV2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 88,
    viewBox: "0 0 70 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.457 22.1934C69.043 22.7793 69.375 23.5703 69.375 24.4004V84.625C69.375 86.3535 67.9785 87.75 66.25 87.75H3.75C2.02148 87.75 0.625 86.3535 0.625 84.625V3.375C0.625 1.64648 2.02148 0.25 3.75 0.25H45.2246C46.0547 0.25 46.8555 0.582031 47.4414 1.16797L68.457 22.1934ZM62.168 25.8359L43.7891 7.45703V25.8359H62.168Z",
    fill: "#005B9B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileV2);
export default __webpack_public_path__ + "static/media/FileV2.4905ce7bc59491d576d7e488c5bf6a21.svg";
export { ForwardRef as ReactComponent };